import CompanyFeatures from "./CompanyFeatures";

export default CompanyFeatures;
